import { Component, Injector, Input, forwardRef } from '@angular/core';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgForm,
} from '@angular/forms';
import { AttributeOption } from '@app/shared/interfaces/Attribute';
import { Translation } from '@app/shared/interfaces/Translation';
import { tap } from 'rxjs';

@Component({
  selector: 'app-product-field-multiselect',
  templateUrl: './product-field-multiselect.component.html',
  styleUrls: ['./product-field-multiselect.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldMultiselectComponent),
      multi: true,
    },
  ],
})
export class ProductFieldMultiselectComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor
{
  languages: DropDownOption[] = [];
  addOptionDrawer: boolean = false;
  @Input() enableCreateOption: boolean = false;
  value: any[] = [];
  onChange: any = (value: any) => {};
  onTouched: any = () => {};
  constructor(injector: Injector) {
    super(injector);
  }
  writeValue(obj: any): void {
    if (obj == null) return;

    this.value = obj;
    if (this.value instanceof Array) {
      if (this.value.includes('-100')) {
        this.addOptionDrawer = true;
        this.value = this.value.filter((x) => x !== '-100');
      }
    }

    if (typeof this.value === 'object') {
      const obj = this.value as any;
      const keys = Object.keys(obj);
      if (
        keys.includes(this.controlName) &&
        typeof obj[this.controlName] == 'string'
      ) {
        const value = obj[this.controlName] as string;
        if (value != null)
          setTimeout(() => {
            this.value = value.split(',').map((x) => +obj);
          }, 400);
      }
    }
    this.onChange(this.value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  override ngOnInit(): void {
    this.languages = this.dropDownsMetaData['languages'];
  }
  postOption(data: NgForm) {
    if (data.valid) {
      const value = data.value;
      const option: AttributeOption = {
        Name: value.name,
        Value: value.name,
        AttributeId: +this.field.Code,
        IsDefault: false,
        Id: 0,
        Translations: Object.keys(value)
          .filter((x) => !isNaN(+x) && value[x] != null && value[x] !== '')
          .map((langId) => {
            const translation: Translation = {
              Label: value[langId],
              LanguageId: +langId,
              ObjectType: 3,
              ObjectId: +this.controlName,
              ObjectField: 'Name',
            };
            return translation;
          }),
      };
      this.subscriptions.push(
        this.attributesService
          .postAttributeOption(option)
          .pipe(
            tap((newOpt: any) => {
           
              this.message.success('option added successfully.');
              this.dropDownsMetaData[this.field.Code].push({
                Code: newOpt.Id,
                Label: newOpt.Name,
              });
              const controlValue = this.value;
              let valuesArray: string[] = [newOpt.Id];
              if (controlValue != null) {
                valuesArray = [...valuesArray, ...controlValue];
              }
              valuesArray = valuesArray.filter((x) => x !== '-100');
              this.onChange(this.value);
              this.addOptionDrawer = false;
            })
          )
          .subscribe()
      );
    } else if (data.errors != null) {
      const errs = data.errors;
      this.message.error('please check inputs and try again');
    }
  }
}
